import { http } from "./http";

export type DeployStatus = "queued" | "running" | "succeeded" | "failed" | "rolled_back";

export interface DeployTarget {
  uuid: string;
  name: string;
  driver: "ssh" | "manual";
  environment: string;
  host: string | null;
  port: number;
  username: string | null;
  directory: string | null;
  domain: string | null;
  health_path: string;
  keep_releases: number;
  is_active: boolean;
  /** Indicadores: o segredo em si NUNCA vem do backend. */
  has_private_key: boolean;
  has_password: boolean;
  ssh_key_fingerprint: string | null;
  env_keys: string[];
  last_deployed_at: string | null;
}

export interface DeploymentLogEntry {
  level: string;
  stage: string | null;
  message: string;
  context: Record<string, unknown> | null;
  logged_at: string;
}

export interface DeploymentItem {
  uuid: string;
  environment: string;
  target: string;
  target_name: string | null;
  status: DeployStatus;
  url: string | null;
  commit: string | null;
  release: string | null;
  previous_release: string | null;
  can_rollback: boolean;
  author: string | null;
  error: string | null;
  started_at: string | null;
  finished_at: string | null;
  created_at: string;
  logs?: DeploymentLogEntry[];
}

export interface DeployOverview {
  enabled: boolean;
  targets: DeployTarget[];
  deployments: DeploymentItem[];
  manual: { summary: string; steps: string[] };
}

export interface DeployTargetInput {
  name?: string;
  driver?: "ssh" | "manual";
  environment?: string;
  host?: string | null;
  port?: number;
  username?: string | null;
  directory?: string | null;
  domain?: string | null;
  health_path?: string;
  keep_releases?: number;
  is_active?: boolean;
  ssh_private_key?: string;
  ssh_password?: string | null;
  env_values?: Record<string, string>;
}

export const deployService = {
  overview: (project: string) => http.get<DeployOverview>(`/projects/${project}/deploy`),
  createTarget: (project: string, data: DeployTargetInput) =>
    http.post<DeployTarget>(`/projects/${project}/deploy/targets`, data),
  updateTarget: (project: string, target: string, data: DeployTargetInput) =>
    http.put<DeployTarget>(`/projects/${project}/deploy/targets/${target}`, data),
  deleteTarget: (project: string, target: string) =>
    http.delete<{ deleted: boolean }>(`/projects/${project}/deploy/targets/${target}`),
  run: (project: string, target: string) =>
    http.post<DeploymentItem>(`/projects/${project}/deploy/targets/${target}/run`, {}),
  show: (project: string, deployment: string) =>
    http.get<DeploymentItem>(`/projects/${project}/deploy/${deployment}`),
  rollback: (project: string, deployment: string) =>
    http.post<DeploymentItem>(`/projects/${project}/deploy/${deployment}/rollback`, {}),
};
